"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterRpcRemote = exports.ROUTING_TIMEOUT = void 0;
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const RpcRemote_1 = require("../contact/RpcRemote");
const getPreviousPeer_1 = require("./getPreviousPeer");
const identifiers_1 = require("../../identifiers");
const logger = new utils_1.Logger(module);
// default timeout
exports.ROUTING_TIMEOUT = 2000;
class RouterRpcRemote extends RpcRemote_1.RpcRemote {
    async routeMessage(params) {
        const message = {
            target: params.target,
            sourcePeer: params.sourcePeer,
            message: params.message,
            requestId: params.requestId ?? (0, uuid_1.v4)(),
            reachableThrough: params.reachableThrough ?? [],
            routingPath: params.routingPath,
            parallelRootNodeIds: params.parallelRootNodeIds
        };
        const options = this.formDhtRpcOptions({
            connect: false
        });
        try {
            const ack = await this.getClient().routeMessage(message, options);
            // Success signal if sent to destination and error includes duplicate
            if (ack.error === DhtRpc_1.RouteMessageError.DUPLICATE
                && (0, utils_1.areEqualBinaries)(params.target, this.getPeerDescriptor().nodeId)) {
                return true;
            }
            else if (ack.error !== undefined) {
                return false;
            }
        }
        catch (err) {
            const previousPeer = (0, getPreviousPeer_1.getPreviousPeer)(params);
            const fromNode = previousPeer
                ? (0, identifiers_1.toNodeId)(previousPeer)
                : (0, identifiers_1.toNodeId)(params.sourcePeer);
            const toNode = (0, identifiers_1.toNodeId)(this.getPeerDescriptor());
            logger.trace(`Failed to send routeMessage from ${fromNode} to ${toNode}`, { err });
            return false;
        }
        return true;
    }
    async forwardMessage(params) {
        const message = {
            target: params.target,
            sourcePeer: params.sourcePeer,
            message: params.message,
            requestId: params.requestId ?? (0, uuid_1.v4)(),
            reachableThrough: params.reachableThrough ?? [],
            routingPath: params.routingPath,
            parallelRootNodeIds: params.parallelRootNodeIds
        };
        const options = this.formDhtRpcOptions({
            connect: false
        });
        try {
            const ack = await this.getClient().forwardMessage(message, options);
            if (ack.error !== undefined) {
                return false;
            }
        }
        catch (err) {
            const previousPeer = (0, getPreviousPeer_1.getPreviousPeer)(params);
            const fromNode = previousPeer
                ? (0, identifiers_1.toNodeId)(previousPeer)
                : (0, identifiers_1.toNodeId)(params.sourcePeer);
            const toNode = (0, identifiers_1.toNodeId)(this.getPeerDescriptor());
            logger.trace(`Failed to send forwardMessage from ${fromNode} to ${toNode}`, { err });
            return false;
        }
        return true;
    }
}
exports.RouterRpcRemote = RouterRpcRemote;
//# sourceMappingURL=RouterRpcRemote.js.map